import { ColDef, ICellRendererParams } from "ag-grid-community";
import { FilteredEc2ResourceItem } from "../../../../../../../services/cloudchipr.api";
import { DateTimeCellRenderer } from "../column-def-cell-renderers/DateTimeCellRenderer";

export const getResourceCreationTimeColumnDef = (
  headerName: string,
): ColDef => ({
  headerName,
  field: "resource.created_at",
  cellRenderer: ({ data }: ICellRendererParams<FilteredEc2ResourceItem>) => {
    if (!data) {
      return null;
    }

    return <DateTimeCellRenderer data={data?.resource?.created_at ?? ""} />;
  },
});
